import { frontendURL } from 'dashboard/helper/URLHelper';
import {
  ROLES,
  CONVERSATION_PERMISSIONS,
} from 'dashboard/constants/permissions.js';
import AppEmbed from './AppEmbed.vue';

export const routes = [
  {
    path: frontendURL('accounts/:accountId/apps/:appSlug'),
    name: 'tbs_apps_embed',
    component: AppEmbed,
    meta: {
      permissions: [...ROLES, ...CONVERSATION_PERMISSIONS],
    },
  },
];
